if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Mobile sticky add-to-cart for product pages.
// Keeps the real Shopify product form as the single source of truth for variants,
// bundles and future selling plans, while showing a compact bar after checkout
// controls have scrolled above the viewport.
(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  const INFO_SELECTOR = '#MainContent [id^="ProductInfo-"].product__info-container';

  const compactText = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const getPriceText = (info, buttons) => {
    const bundlePrice = info.querySelector(
      '.kaching-bundles__bar--selected .kaching-bundles__bar-price'
    );
    if (compactText(bundlePrice?.textContent)) return compactText(bundlePrice.textContent);

    const subscriptionWidget = info.querySelector(
      '.kaching-subscriptions__widget[data-selling-plan-id]'
    );
    const subscriptionPrice = subscriptionWidget?.querySelector(
      '.ks-card-wrapper.selected [data-testid="discounted-price"]'
    );
    if (compactText(subscriptionPrice?.textContent)) {
      return compactText(subscriptionPrice.textContent);
    }

    const oneTimePrice = info.querySelector(
      '.kaching-subscriptions__card-wrapper.one-time-purchase.selected [data-testid="one-time-price"]'
    );
    if (compactText(oneTimePrice?.textContent)) return compactText(oneTimePrice.textContent);

    const mainPrice = [...info.querySelectorAll('.price:not(.price--sticky)')].find(
      (price) => compactText(price.textContent)
    );
    if (mainPrice) {
      const enhancedPrice = mainPrice.querySelector('.price--enhanced .primary.new-price');
      if (compactText(enhancedPrice?.textContent)) return compactText(enhancedPrice.textContent);

      const priceItem = mainPrice.classList.contains('price--on-sale')
        ? mainPrice.querySelector('.price__sale .price-item--sale')
        : mainPrice.querySelector('.price__regular .price-item--regular');
      if (compactText(priceItem?.textContent)) return compactText(priceItem.textContent);
    }

    const fallbackPrice = buttons.querySelector(
      '.price--sticky .price__regular .price-item--regular, .price--sticky .price-item--sale'
    );
    return compactText(fallbackPrice?.textContent);
  };

  const initProductPurchase = (info) => {
    if (!info || info.dataset.ozStickyCartReady === 'true') return;

    const form = info.querySelector(
      'product-form form[data-type="add-to-cart-form"][action*="/cart/add"]'
    );
    const buttons = form?.querySelector('.product-form__buttons');
    const mainButton = buttons?.querySelector(
      'button[type="submit"][name="add"].product-form__submit'
    );
    if (!form || !buttons || !mainButton) return;

    info.dataset.ozStickyCartReady = 'true';
    buttons.classList.remove('sticky-form');

    const bar = document.createElement('div');
    bar.className = 'oz-mobile-sticky-cart';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =       '<div class="oz-mobile-sticky-cart__inner">' +
        '<div class="oz-mobile-sticky-cart__price" aria-live="polite"></div>' +
        '<button type="button" class="oz-mobile-sticky-cart__button button button--full-width button--accent-1"></button>' +
      '</div>';
    document.body.appendChild(bar);

    const barPrice = bar.querySelector('.oz-mobile-sticky-cart__price');
    const barButton = bar.querySelector('.oz-mobile-sticky-cart__button');
    let frameRequested = false;

    const syncState = () => {
      frameRequested = false;
      barPrice.textContent = getPriceText(info, buttons);

      const buttonLabel = compactText(
        mainButton.querySelector('span')?.textContent || mainButton.textContent
      );
      barButton.textContent = buttonLabel || 'Add to cart';

      const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      barButton.disabled = disabled;
      barButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      bar.classList.toggle('is-loading', mainButton.classList.contains('loading'));
    };

    const scheduleSync = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(syncState);
    };

    const updateVisibility = () => {
      const purchaseControlsHavePassed = buttons.getBoundingClientRect().bottom <= 0;
      const show = MOBILE_QUERY.matches && purchaseControlsHavePassed;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('oz-mobile-sticky-cart-visible', show);
    };

    barButton.addEventListener('click', () => {
      if (barButton.disabled) return;
      mainButton.click();
      window.requestAnimationFrame(syncState);
    });

    info.addEventListener('change', scheduleSync);
    info.addEventListener('click', () => window.setTimeout(scheduleSync, 0));
    document.addEventListener('kaching-subscriptions:selling-plan-change', scheduleSync);

    const observer = new MutationObserver(scheduleSync);
    observer.observe(info, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'class',
        'disabled',
        'aria-disabled',
        'checked',
        'data-selling-plan-id'
      ]
    });

    let scrollFrameRequested = false;
    const scheduleVisibility = () => {
      if (scrollFrameRequested) return;
      scrollFrameRequested = true;
      window.requestAnimationFrame(() => {
        scrollFrameRequested = false;
        updateVisibility();
      });
    };

    window.addEventListener('scroll', scheduleVisibility, { passive: true });
    window.addEventListener('resize', scheduleVisibility);
    MOBILE_QUERY.addEventListener?.('change', scheduleVisibility);

    syncState();
    updateVisibility();
  };

  const initAllProductPurchases = (root = document) => {
    if (root.matches?.(INFO_SELECTOR)) initProductPurchase(root);
    root.querySelectorAll?.(INFO_SELECTOR).forEach(initProductPurchase);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllProductPurchases());
  } else {
    initAllProductPurchases();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllProductPurchases(event.target);
  });
})();
